import gql from 'graphql-tag';

// Organization Engagement Report - Curriculum (panel w/ curriculum selector and radial/bar charts for each school)
const GET_ORGANIZATION_ENGAGEMENT_CURRICULUM_REPORT = gql`
  query getOrganizationEngagementCurriculumReport(
    $organizationId: Int!
    $productCurriculumId: Int!
  ) {
    prmOrganizationEngagementCurriculumReport(
      where: { organizationId: $organizationId, productCurriculumId: $productCurriculumId }
    ) {
      productCurriculumId
      productCurriculum {
        id
        name
      }
      organizationCurriculumProgress {
        organizationId
        organization {
          id
          name
        }
        averageLessonAssignedCount
        averageLessonCompletedCount
        totalLessonCount
        overallCompletionStats {
          metSkillPercentage
          unmetSkillPercentage
          metSkillWithSupportPercentage
          metSkillWithoutSupportPercentage
        }
      }
    }
  }
`;

export default GET_ORGANIZATION_ENGAGEMENT_CURRICULUM_REPORT;
